
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publisher/detail/[id]",
      function () {
        return require("private-next-pages/publisher/detail/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publisher/detail/[id]"])
      });
    }
  